import React from "react";

const Contact = () => {
  return (
    <main>
      {/* breadcrumb start */}
      <section id="h1-breadcrumb">
        <div className="h1-breadcrumb w-full h-fit overflow-hidden relative bg-main-gray pb-16 md:pb-[120px]">
          <img
            src="./assets/images/home-nine/hero-bg.png"
            alt=""
            className="absolute z-0 mx-auto cta_bg_anim h-full w-full"
          />

          <div
            className="win-grid win-grid-bg w-full h-full absolute left-0 top-0 z-0"
            id="win-grid"
          />
          <div className="absolute left-1/4 w-full top-[300px] overflow-hidden z-0 pointer-events-none">
            <div className="flex justify-center">
              <img src="assets/images/home-one-hero-circle-shadow.svg" alt="" />
            </div>
          </div>
          <div className="theme-container mx-auto h-fit w-fit relative z-0">
            <div className="mt-[120px] md:mt-[200px] w-fit mx-auto relative">
              <h1
                data-aos="fade"
                className="text-main-black text-34 font-semibold w-full text-center max-w-[500px]"
              >
                Contact Information
              </h1>
            </div>
          </div>
        </div>
      </section>
      {/* breadcrumb end */}

      {/* blog start  */}
      <section
        className="w-full py-16 md:py-[130px] max-md:pt-[20px]"
        data-aos="fade"
      >
        <div className="theme-container mx-auto w-full text-paragraph">
          <div className="grid grid-cols-6 md:grid-cols-12 items-center">
            <div className="col-span-6">
              <div className="contact-style-one-info md:pr-[200px]">
                <ul>
                  <li>
                    <div className="icon">
                      <i className="fas fa-phone-alt" aria-hidden="true" />
                    </div>
                    <div className="content">
                      <h5 className="title">Hotline</h5>
                      <a
                        href="tel:919711300776"
                        className="text-[16px] !font-medium !text-paragraph"
                      >
                        tel:+91-9211603304
                      </a>
                    </div>
                  </li>
                  <li>
                    <div className="icon">
                      <i className="fas fa-map-marker-alt" aria-hidden="true" />
                    </div>
                    <div className="info">
                      <h5 className="title">Our Location</h5>
                      <p className="!font-medium !text-paragraph">
                        C-171, Ground Floor Sector-63 Noida Uttar Pradesh 201301
                      </p>
                    </div>
                  </li>
                  <li>
                    <div className="icon">
                      <i
                        className="fas fa-envelope-open-text"
                        aria-hidden="true"
                      />
                    </div>
                    <div className="info">
                      <h5 className="title">Official Email</h5>
                      <a
                        href="mailto:support@clickfordoctor.com"
                        className="text-[16px] !font-medium !text-paragraph"
                      >
                        support@clickfordoctor.com
                      </a>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-span-6 flex justify-center items-center mt-5 md:mt-0">
              <img
                src="assets/images/contact.jpg"
                alt=""
                className="w-full rounded-[40px] max-md:mt-[40px]"
              />
            </div>
          </div>
        </div>
      </section>
      {/* blog end  */}
    </main>
  );
};

export default Contact;
